module.exports = __webpack_public_path__ + "img/Lime-24-Blog-Banner13.c3594dcd.jpg";